<app-layout>
  <div class="carrinho">
    <div class="left-column d-flex flex-column gap-2">
      @if (cartProducts.length > 0) {
        <div class="carrinho__event-group d-flex flex-column gap-2">
          @if (eventInfo) {
            <div class="event-info">
              <app-event-card [fullWidth]="true" [event]="eventInfo"></app-event-card>
            </div>
          }
          <div class="carrinho__container card">
            <div class="carrinho__resumo-header">
              <p class="h4">Ingressos</p>
            </div>
            <app-cart-items [cartProducts]="cartProducts"></app-cart-items>
          </div>
        </div>
      }
      <div class="carrinho__container card">
        <div class="carrinho__resumo-header">
          <p class="h4">Resumo da compra</p>
        </div>

        <div class="carrinho__resumo__item mt-2">
          <span class="carrinho__resumo__item__label h6">Quantidade de ingressos</span>
          <span class="carrinho__resumo__item__valor h6">{{ totalItems }}</span>
        </div>
        <div class="carrinho__resumo__item">
          <span class="carrinho__resumo__item__label h6">Total Ingressos</span>
          <span class="carrinho__resumo__item__valor h6" style="font-weight: bold">
            {{ totalPrice | currency: "BRL" }}
          </span>
        </div>
        @if (totalTax > 0) {
          <div class="carrinho__resumo__item">
            <span class="carrinho__resumo__item__label h6">Taxa de Serviço</span>
            <span class="carrinho__resumo__item__valor h6" style="font-weight: bold">
              + {{ totalTax | currency: "BRL" }}
            </span>
          </div>
        }
        @if (totalConsumption > 0) {
          <div class="carrinho__resumo__item">
            <span class="carrinho__resumo__item__label h6">Consumação</span>
            <span class="carrinho__resumo__item__valor h6" style="font-weight: bold">
              + {{ totalConsumption | currency: "BRL" }}
            </span>
          </div>
        }
        @if (processingFeeDisplay > 0) {
          <div class="carrinho__resumo__item">
            <span class="carrinho__resumo__item__label h6"
              >Taxa de processamento
              @if (hasInstallmentInterest) {
                &nbsp;+ juros
              }
            </span>
            <span class="carrinho__resumo__item__valor h6" style="font-weight: bold">
              + {{ processingFeeDisplay | currency: "BRL" }}
            </span>
          </div>
        }

        @if (totalPrice > 0) {
          <div class="carrinho__cupom">
            <label class="form-label carrinho__cupom-label" for="coupon-code">Cupom de desconto</label>
            @if (appliedCoupon) {
              <div class="carrinho__cupom-aplicado">
                <span class="carrinho__cupom-codigo"><i class="pi pi-tag"></i> {{ appliedCoupon.code }}</span>
                <button type="button" class="carrinho__cupom-remover" (click)="removeCoupon()">Remover</button>
              </div>
              @if (couponCoverageLabel) {
                <small class="carrinho__cupom-cobertura">{{ couponCoverageLabel }}</small>
              }
              @if (showCouponTicketSelector) {
                <div class="carrinho__cupom-ingresso">
                  <label class="form-label carrinho__cupom-label" for="coupon-ticket">Aplicar o desconto em</label>
                  <select
                    id="coupon-ticket"
                    class="form-select"
                    [disabled]="couponLoading"
                    (change)="onCouponTicketChange(+$any($event.target).value)">
                    @for (opt of couponEligibleOptions; track opt.value) {
                      <option [value]="opt.value" [selected]="opt.value === appliedCoupon.ticket_id">
                        {{ opt.label }}
                      </option>
                    }
                  </select>
                </div>
              }
            } @else {
              <div class="carrinho__cupom-input">
                <input
                  id="coupon-code"
                  type="text"
                  class="form-control"
                  placeholder="Digite o código do cupom"
                  [formControl]="couponControl"
                  (keyup.enter)="applyCoupon()" />
                <app-button styleType="outlined" [loading]="couponLoading" (btnClick)="applyCoupon()"
                  >Aplicar</app-button
                >
              </div>
            }
            @if (couponError) {
              <small class="carrinho__cupom-erro">{{ couponError }}</small>
            }
          </div>

          @if (discountAmount > 0) {
            <div class="carrinho__resumo__item">
              <span class="carrinho__resumo__item__label h6">Subtotal</span>
              <span class="carrinho__resumo__item__valor h6" style="font-weight: bold">
                {{ subtotalBeforeDiscount | currency: "BRL" }}
              </span>
            </div>
            <div class="carrinho__resumo__item">
              <span class="carrinho__resumo__item__label h6">Desconto</span>
              <span class="carrinho__resumo__item__valor h6" style="font-weight: bold">
                - {{ discountAmount | currency: "BRL" }}
              </span>
            </div>
          }
        }

        <div class="carrinho__resumo__item">
          <span class="carrinho__resumo__item__label h5">Total</span>
          <span class="carrinho__resumo__item__valor h5" style="font-weight: bold">
            {{ displayTotal | currency: "BRL" }}
          </span>
        </div>
      </div>
    </div>

    <div class="right-column">
      @if (onlineSalesClosed) {
        <div class="alert alert-info" role="status">Vendas online encerradas no início do evento. Não é possível iniciar outra compra. Pagamentos já iniciados continuam sendo acompanhados.</div>
      }
      @if (cartProducts.length > 0) {
        <app-countdown-timer [cartCreationDate]="cartProducts[0].created_at"></app-countdown-timer>
      }
      <div class="carrinho__container card">
        @if (isSeller) {
          <app-cart-customer-info-section
            [highlightErrorsTrigger]="clientInfoHighlightTrigger"
            (clientInfoChange)="handleClientInfoChange($event)"></app-cart-customer-info-section>
        } @else {
          <p class="h5">Os dados da compra serão enviados para o e-mail:</p>
          <div class="">
            <p class="h6">{{ currentUser?.email }}</p>
            <app-button (click)="openModalSignUp()">Atualizar meus dados</app-button>
          </div>
        }
      </div>
      @if (cartProducts.length > 0) {
        <div class="carrinho__container card">
          @if (showAddress && !isSeller) {
            <app-cart-address-section
              [currentUser]="currentUser"
              (continueToCheckoutClick)="handleContinueToCheckoutClick()" />
          } @else {
            <app-checkout
              [salesClosed]="onlineSalesClosed"
              [sellerId]="sellerId"
              [orderTotal]="chargeableTotal"
              [couponDiscount]="discountAmount"
              [isSeller]="isSeller"
              [eventId]="cartProducts[0].event_id"
              [marketingContext]="marketingCheckoutContext"
              [clientInfo]="clientInfo"
              [showPaymentMethods]="totalPrice > 0"
              (previouSectionClick)="handleBackToaddressClick()"
              (requestClientInfoHighlight)="handleRequestClientInfoHighlight()"
              (paymentMethodChange)="onPaymentMethodChange($event)"
              (installmentChange)="onInstallmentChange($event)"
              (couponExpired)="handleCouponExpired()" />
          }
        </div>
      }
    </div>
  </div>
</app-layout>
